export default "__VITE_ASSET__db4bd647__"